import React from 'react'
import './footer.css'
import footer_logo from 'assets/footer/logo.svg';
import { Link } from 'react-router-dom';

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className='footer-container'>
      <div className='container'>
        <div className="footer-row">
          <div className="footer-box">
            <div className="footer-logo">
              <Link to="../"><img src={footer_logo} alt="Footer logo" /></Link>
              <p>Committed to customer <br/> Satisfaction</p>
            </div>
          </div>
          <div className="footer-box social-media">
            <Link target='_blank' to="https://www.twitter.com/login/"><i className="fa-brands fa-twitter"></i></Link>
            <Link target='_blank' to="https://www.linkedin.com/login/"><i className="fa-brands fa-linkedin"></i></Link>
            <Link target='_blank' to="https://www.facebook.com/login/"><i className="fa-brands fa-square-facebook"></i></Link>
          </div>
          <div className="footer-box our-feature">
            <Link to="../services" className="footer-button--primary">Services</Link>
            <Link to="../works" className="footer-button--primary">Works</Link>
            <Link to="../privacy-policy" className="footer-button--primary">Privacy Policy</Link>
          </div>
          <div className="footer-box our-feature">
            <Link to="../inquiry" className="footer-button--primary">Inquiry</Link>
            <Link to="../choose-plan" className="footer-button--primary">Pricing</Link>
            <Link to="../about-us" className="footer-button--primary">About Us</Link>
            <Link to="../term-and-condition" className="footer-button--primary">Term and Conditions</Link>
          </div>
          <div onClick={scrollToTop} className="footer-box top-arrow">
            <i className="fa-solid fa-arrow-up"></i>
          </div>
        </div>
        <div className="footer-text">
          <h3>© 2025 CRM. All right reserved</h3>
        </div>
      </div>
    </div>
  )
}

export default Footer